import React, { useState } from 'react';
import { SaveIcon, UserIcon, BuildingIcon, PhoneIcon, MailIcon } from 'lucide-react';
import DashboardLayout from '../components/layout/DashboardLayout';
const UpdateProfilePage = () => {
  const [formData, setFormData] = useState({
    merchantName: 'Gadgets Zone',
    ownerName: 'Waqas Ahmed',
    email: 'waqas@gadgetszone.pk',
    phone: '+92 300 1234567',
    address: '123 Main Street, Karachi',
    city: 'Karachi',
    country: 'Pakistan',
    postalCode: '75500'
  });
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccessMessage('');
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    setSuccessMessage('Profile updated successfully!');
    setIsLoading(false);
  };
  return <DashboardLayout data-id="element-2213">
      <div className="mb-6" data-id="element-2214">
        <h1 className="text-2xl font-bold text-[#0D3B66]" data-id="element-2215">Update Profile</h1>
        <p className="text-gray-600" data-id="element-2216">
          Manage your merchant profile information
        </p>
      </div>

      <div className="max-w-3xl" data-id="element-2217">
        <div className="bg-white rounded-xl shadow-sm border border-[#E2E8F0] p-6 md:p-8" data-id="element-2218">
          {successMessage && <div className="mb-6 p-4 bg-green-50 border border-green-200 text-green-700 rounded-lg" data-id="element-2219">
              {successMessage}
            </div>}

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2220">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2221">
              <div data-id="element-2222">
                <label htmlFor="merchantName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2223">
                  Merchant Name
                </label>
                <div className="relative" data-id="element-2224">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2225">
                    <BuildingIcon className="h-5 w-5 text-gray-400" data-id="element-2226" />
                  </div>
                  <input type="text" id="merchantName" name="merchantName" value={formData.merchantName} onChange={handleChange} className="w-full pl-10 pr-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2227" />
                </div>
              </div>

              <div data-id="element-2228">
                <label htmlFor="ownerName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2229">
                  Owner Name
                </label>
                <div className="relative" data-id="element-2230">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2231">
                    <UserIcon className="h-5 w-5 text-gray-400" data-id="element-2232" />
                  </div>
                  <input type="text" id="ownerName" name="ownerName" value={formData.ownerName} onChange={handleChange} className="w-full pl-10 pr-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2233" />
                </div>
              </div>

              <div data-id="element-2234">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2235">
                  Email Address
                </label>
                <div className="relative" data-id="element-2236">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2237">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-2238" />
                  </div>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full pl-10 pr-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2239" />
                </div>
              </div>

              <div data-id="element-2240">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2241">
                  Phone Number
                </label>
                <div className="relative" data-id="element-2242">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2243">
                    <PhoneIcon className="h-5 w-5 text-gray-400" data-id="element-2244" />
                  </div>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full pl-10 pr-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2245" />
                </div>
              </div>

              <div className="md:col-span-2" data-id="element-2246">
                <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2247">
                  Address
                </label>
                <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} className="w-full px-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2248" />
              </div>

              <div data-id="element-2249">
                <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2250">
                  City
                </label>
                <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className="w-full px-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2251" />
              </div>

              <div data-id="element-2252">
                <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2253">
                  Postal Code
                </label>
                <input type="text" id="postalCode" name="postalCode" value={formData.postalCode} onChange={handleChange} className="w-full px-4 py-3 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:border-transparent" data-id="element-2254" />
              </div>
            </div>

            <div className="pt-4" data-id="element-2255">
              <button type="submit" disabled={isLoading} className="w-full md:w-auto px-8 py-3 bg-[#F5A623] text-[#0D3B66] font-semibold rounded-lg hover:bg-[#FFD54F] focus:outline-none focus:ring-2 focus:ring-[#F5A623] focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center" data-id="element-2256">
                <SaveIcon className="h-5 w-5 mr-2" data-id="element-2257" />
                {isLoading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </DashboardLayout>;
};
export default UpdateProfilePage;